export enum SpecialEquipment {
  NONE = 'none',
  HI_AB = 'hi-ab',
  MOFFETT = 'moffett',
}
